export default "__VITE_ASSET__76350bbb__"